// src/Int.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Int_default = createIcon({
  displayName: "Int",
  viewBox: "0 0 50 34",
  path: /* @__PURE__ */ jsxs(Fragment, {
    children: [
      /* @__PURE__ */ jsx("path", {
        id: "Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 1H49V33H1V1Z",
        fill: "#4D98FF"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 30C32.1797 30 38 24.1797 38 17C38 9.8203 32.1797 4 25 4C17.8203 4 12 9.8203 12 17C12 24.1797 17.8203 30 25 30ZM25 28C31.0751 28 36 23.0751 36 17C36 10.9249 31.0751 6 25 6C18.9249 6 14 10.9249 14 17C14 23.0751 18.9249 28 25 28Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Rectangle 105",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 11H36L37 13H13L14 11Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Rectangle 105_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 21H37L36 23H14L13 21Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        id: "Combined Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M25 30C28.866 30 32 24.1797 32 17C32 9.8203 28.866 4 25 4C21.134 4 18 9.8203 18 17C18 24.1797 21.134 30 25 30ZM25 28C27.7614 28 30 23.0751 30 17C30 10.9249 27.7614 6 25 6C22.2386 6 20 10.9249 20 17C20 23.0751 22.2386 28 25 28Z",
        fill: "white"
      }),
      /* @__PURE__ */ jsx("path", {
        d: "M1 1V0H0V1H1ZM49 1H50V0H49V1ZM49 33V34H50V33H49ZM1 33H0V34H1V33ZM1 2H49V0H1V2ZM48 1V33H50V1H48ZM49 32H1V34H49V32ZM2 33V1H0V33H2Z",
        fill: "#F3F6F9"
      })
    ]
  })
});

export {
  Int_default
};
